export default "__VITE_ASSET__Chqljm8x__"